import React, { useState } from 'react';
import { ArrowRightIcon, ShieldCheckIcon, ChevronDownIcon, ChevronUpIcon, ZapIcon } from 'lucide-react';
import { CountdownBadge } from './CountdownBadge';
import { trackAddToCart } from './MetaPixel';
const CHECKOUT_URL = 'https://pay.hotmart.com/A105003730N?checkoutMode=10';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-spiritual-700/40 rounded-xl overflow-hidden" data-id="element-69">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left hover:bg-spiritual-800/30 transition-colors" aria-expanded={isOpen} data-id="element-70">
        <span className="text-spiritual-100 font-body font-bold text-sm md:text-base pr-4" data-id="element-71">
          {question}
        </span>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-spiritual-400 flex-shrink-0" aria-hidden="true" data-id="element-72" /> : <ChevronDownIcon className="w-5 h-5 text-spiritual-400 flex-shrink-0" aria-hidden="true" data-id="element-73" />}
      </button>
      {isOpen && <div className="px-5 pb-5" data-id="element-74">
          <p className="text-spiritual-200/80 font-body text-sm leading-relaxed" data-id="element-75">
            {answer}
          </p>
        </div>}
    </div>;
}
export function PricingSection() {
  const handleCTA = () => {
    trackAddToCart();
  };
  return <section id="comprar" className="bg-gradient-to-b from-spiritual-900 via-spiritual-800 to-spiritual-900 py-16 md:py-24 relative overflow-hidden" data-id="element-76">
      <div className="absolute inset-0 opacity-[0.05]" data-id="element-77">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-spiritual-400 rounded-full blur-3xl" data-id="element-78" />
      </div>

      <div className="max-w-3xl mx-auto px-5 md:px-8 relative z-10" data-id="element-79">
        {/* Offer Block */}
        <div className="text-center mb-10" data-id="element-80">
          <span className="inline-flex items-center gap-2 text-spiritual-400 font-body text-sm uppercase tracking-widest mb-4" data-id="element-81">
            <ZapIcon className="w-4 h-4" aria-hidden="true" data-id="element-82" />
            Oferta Especial
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-spiritual-100 leading-tight mb-4" data-id="element-83">
            Rompe el patrón de pobreza{' '}
            <span className="text-gold-gradient" data-id="element-84">hoy</span>
          </h2>
          <p className="text-spiritual-200/80 font-body leading-relaxed max-w-2xl mx-auto" data-id="element-85">
            No es un gasto, es la inversión para que el apellido de tus hijos
            esté ligado a la abundancia y no a la lucha constante.
          </p>
        </div>

        {/* Price Card */}
        <div className="bg-spiritual-800/60 border-gold-glow rounded-3xl p-8 md:p-12 mb-12 text-center" data-id="element-86">
          <p className="text-spiritual-300/60 font-body text-sm mb-1" data-id="element-87">
            Paquete Completo
          </p>
          <h3 className="font-heading font-bold text-spiritual-100 text-2xl md:text-3xl mb-6" data-id="element-88">
            Código de Sanación del Árbol
          </h3>

          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-89">
            <span className="text-spiritual-300/40 font-body text-xl line-through" data-id="element-90">
              $45.99 USD
            </span>
            <span className="bg-spiritual-400/20 text-spiritual-400 font-body font-bold text-sm px-3 py-1 rounded-full" data-id="element-91">
              Ahorra $34
            </span>
          </div>

          <div className="flex items-baseline justify-center gap-1 mb-6" data-id="element-92">
            <span className="text-5xl md:text-7xl font-heading font-bold text-gold-gradient" data-id="element-93">
              $11.99
            </span>
            <span className="text-spiritual-300/60 font-body text-lg" data-id="element-94">USD</span>
          </div>

          <p className="text-spiritual-200/60 font-body text-sm mb-8" data-id="element-95">
            Pago único · Acceso de por vida · Descarga inmediata
          </p>

          <div className="mb-6" data-id="element-96">
            <CountdownBadge data-id="element-97" />
          </div>

          <a href={CHECKOUT_URL} onClick={handleCTA} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 gold-shimmer text-spiritual-900 font-body font-bold px-10 py-5 rounded-xl text-lg md:text-xl transition-all duration-300 shadow-2xl shadow-spiritual-400/30 transform hover:scale-105 active:scale-95 w-full md:w-auto justify-center" data-id="element-98">
            Quiero Sanar Mi Linaje Ahora
            <ArrowRightIcon className="w-6 h-6" aria-hidden="true" data-id="element-99" />
          </a>

          <p className="mt-4 text-spiritual-300/50 font-body text-xs italic" data-id="element-100">
            Reclama tu abundancia y corta el contrato de escasez antes de que
            pase otro mes de lucha.
          </p>

          <div className="flex items-center justify-center gap-2 mt-6 text-spiritual-300/40 font-body text-xs" data-id="element-101">
            <ShieldCheckIcon className="w-4 h-4" aria-hidden="true" data-id="element-102" />
            <span data-id="element-103">Pago seguro procesado por Hotmart</span>
          </div>
        </div>

        {/* Product Image */}
        <div className="flex justify-center mb-16" data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/pUSaaYEsHUnEUsPi228GQh/Portada_ebook_ipad.png" alt="Código de Sanación del Árbol - eBook" className="w-48 md:w-64 rounded-xl shadow-2xl shadow-spiritual-900/50 opacity-80" data-id="element-105" />
        </div>

        {/* FAQ */}
        <div className="mb-8" data-id="element-106">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-spiritual-100 text-center mb-8" data-id="element-107">
            Preguntas Frecuentes
          </h3>

          <div className="space-y-3" data-id="element-108">
            <FAQItem question="¿Necesito conocer toda mi historia familiar?" answer="No, el cuerpo guarda la información incluso si no tienes datos exactos. El protocolo está diseñado para trabajar con lo que sientes y recuerdas, sin necesidad de un árbol genealógico completo." data-id="element-109" />
            <FAQItem question="¿Esto es religión?" answer="No, es un enfoque basado en psicología transgeneracional y epigenética. No está vinculado a ninguna religión o creencia específica." data-id="element-110" />
            <FAQItem question="¿Cuánto tiempo toma ver resultados?" answer="El alivio emocional es inmediato tras el ritual; los cambios externos suelen aparecer en los primeros 21 días a medida que tu sistema nervioso se recalibra." data-id="element-111" />
            <FAQItem question="¿Es un pago único?" answer="Sí, acceso de por vida al material digital. Pagas una vez y el contenido es tuyo para siempre." data-id="element-112" />
          </div>
        </div>
      </div>
    </section>;
}